export default __webpack_public_path__ + "static/media/Katie.6473d41f.jpeg";